import * as React from 'react'
import {HTMLProps} from 'react'
import omit from 'lodash/omit'
import {asHTMLAttributeValue, fromMaybe} from '@freckle/maybe'
import {cn} from '@frontrow/console/src/lib/utils'
import {INPUT_BASE} from '@frontrow/console/src/lib/form-styles'

import {replaceSmartQuotes as replaceSmartQuotesFn} from '@frontrow/console/src/entities/helpers/string-helper'

type Props = {
  replaceSmartQuotes?: boolean
  onChange: (value: string) => void
  onEnter?: (value: string) => void
  dataTest?: string
  // ref isn't a real prop, and React doesn't know what to do
  // if the component that uses ref isn't an HTML element
  getRef?: React.Ref<HTMLInputElement>
} & Omit<HTMLProps<HTMLInputElement>, 'onChange' | 'onEnter'>

export default function Input(props: Props) {
  const {replaceSmartQuotes, onChange, onEnter, dataTest, className, type} = props

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const rawValue = e.currentTarget.value
    const value = fromMaybe(() => false, replaceSmartQuotes)
      ? replaceSmartQuotesFn(rawValue)
      : rawValue
    onChange(value)
  }

  function handlePressEnter(e: React.KeyboardEvent) {
    if (e.currentTarget instanceof HTMLInputElement && e.key === 'Enter' && onEnter !== undefined) {
      const rawValue = e.currentTarget.value
      const value = fromMaybe(() => false, replaceSmartQuotes)
        ? replaceSmartQuotesFn(rawValue)
        : rawValue
      onEnter(value)
    }
  }

  const isCheckbox = type === 'checkbox'

  const inputProps = {
    ...omit(props, [
      'getRef',
      'onChange',
      'onEnter',
      'replaceSmartQuotes',
      'dataTest',
      'className'
    ]),
    onKeyDown: onEnter ? handlePressEnter : undefined,
    onChange: handleChange,
    'data-test': asHTMLAttributeValue(dataTest),
    className: isCheckbox ? className : cn(INPUT_BASE, className)
  }

  return <input {...inputProps} />
}
